import axios from 'axios'
import URL from '../../../utils/urls'
import { AdfApplicationSink } from '../adf-app-types'

export async function updateAdfApp(adf: AdfApplicationSink) {
    const response = await axios.put(
        URL.bff.adfAppsInternal,
        adf
    );
    return response.data;
}